"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Controls = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _Ai = require("./Ai.styles");

var Controls = (0, _base["default"])("div", {
  target: "e1xynwyb1",
  label: "Controls"
})(_Ai.styles.controls, ";");
exports.Controls = Controls;
var Container = (0, _base["default"])("div", {
  target: "e1xynwyb0",
  label: "Container"
})(_Ai.styles.base, ";");
exports.Container = Container;
//# sourceMappingURL=shared.js.map